import { Promotion } from '@app-types/api';
import { DiscountType } from '@app-types/product';

export class ApiDiscountMapper {
    public static mapPromotionSapic(discount: Promotion): DiscountType {
        return {
            type: discount.type, // @TODO: create specific type and mapper
            value: discount.valeur,
            discount: discount.reduction,
            isIncitation: discount.estIncitation,
            isDiffered: discount.estDifferee,
            duration: discount.duree,
            marketingTypes: discount.proprietesSupplementaires?.typesMarketing ?? [],
            pennant: discount.proprietesSupplementaires?.fanion,
        };
    }
}
